var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0936 26.0914C16.9713 26.269 16.8077 26.4143 16.6167 26.5146C16.4258 26.615 16.2133 26.6674 15.9976 26.6674C15.782 26.6674 15.5695 26.615 15.3786 26.5146C15.1876 26.4143 15.024 26.269 14.9016 26.0914L2.90165 8.75802C2.76275 8.55809 2.68129 8.32393 2.66613 8.08096C2.65098 7.83799 2.70269 7.59551 2.81567 7.37987C2.92864 7.16424 3.09855 6.98368 3.30693 6.85783C3.51532 6.73197 3.75421 6.66563 3.99765 6.66602H27.9976C28.2405 6.66702 28.4785 6.73421 28.6861 6.86037C28.8936 6.98652 29.0628 7.16687 29.1756 7.38201C29.2883 7.59715 29.3402 7.83894 29.3258 8.08139C29.3113 8.32384 29.2311 8.55777 29.0936 8.75802L17.0936 26.0914Z",
    fill: "#B9B9B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyDown);
export default __webpack_public_path__ + "static/media/greyDown.fb1231667ad3689d4bac43b9fd21dcd4.svg";
export { ForwardRef as ReactComponent };